import React, {useState} from 'react';
import styled from 'styled-components/native';
import { View, Text, Pressable } from 'react-native';
import { Link } from 'app/src/utils/routing';
import { elLightGray } from 'app/src/styles/colors';
import { useLocation } from 'react-router-dom';
import Modal from 'app/src/elements/Modal';
import NewSellerUser from './new';
import { SubNavContainer } from 'app/src/elements';

const SubNav = ({refetch}) => {
  const [showAddSellerUserModal, setShowAddSellerUserModal] = useState(false);
  const location = useLocation();
  return (
    <SubNavContainer>
      {getLinks()}
    </SubNavContainer>
  )

  function getLinks() {
    if(location.pathname === "/users") {
      return (
        <View>
          <Pressable
            onPress={() => setShowAddSellerUserModal(true)}
          >
            <Text>+ Add User</Text>
          </Pressable>
          {showAddSellerUserModal &&
            <Modal
              setShowModal={setShowAddSellerUserModal}
              modalType={'Add User'}
            >
              <NewSellerUser
                setShowModal={setShowAddSellerUserModal}
                refetch={refetch}
              />
            </Modal>
          }
        </View>
      )
    }else if(location.pathname === "/users/new") {
      return (
        <Link to="users">
          <Text>Seller Users</Text>
        </Link>
      )
    }
  }
}

export default SubNav;
